import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";
import legalSidebarLinks from "./legalSidebarLinks";

export default function LegalSidebar() {
  const location = useLocation();

  // Expand all groups by default
  const [openGroups, setOpenGroups] = useState(
    Object.fromEntries(legalSidebarLinks.map((g) => [g.group, true]))
  );

  const toggleGroup = (groupName) => {
    setOpenGroups((prev) => ({
      ...prev,
      [groupName]: !prev[groupName],
    }));
  };

  return (
    <div className="bg-yellow-400 p-4 rounded-2xl w-full sm:w-64 shadow-lg">
      <h3 className="text-lg font-bold mb-3 text-black">Legal Center</h3>

      <div className="space-y-2">
        {legalSidebarLinks.map((group) => (
          <div key={group.group} className="bg-white rounded-md shadow-sm">
            {/* Section Header */}
            <button
              onClick={() => toggleGroup(group.group)}
              className="w-full flex justify-between items-center px-4 py-2 text-left font-semibold text-gray-900 hover:bg-yellow-100 transition rounded-t-md"
            >
              {group.group}
              {openGroups[group.group] ? (
                <ChevronUp size={16} className="text-gray-700" />
              ) : (
                <ChevronDown size={16} className="text-gray-700" />
              )}
            </button>

            {/* Expanded Submenu */}
            {openGroups[group.group] && (
              <div className="px-4 py-2 border-t border-gray-200 bg-white rounded-b-md">
                {group.items.map((item) => {
                  const isActive = location.pathname === item.to;
                  return (
                    <Link
                      key={item.to}
                      to={item.to}
                      className={`block text-sm py-1.5 transition ${
                        isActive
                          ? "text-purple-600 font-semibold"
                          : "text-gray-700 hover:text-purple-500"
                      }`}
                    >
                      {item.label}
                    </Link>
                  );
                })}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}